import { render, staticRenderFns } from "./DialogReject.vue?vue&type=template&id=1afda7be&scoped=true&"
import script from "./DialogReject.vue?vue&type=script&lang=js&"
export * from "./DialogReject.vue?vue&type=script&lang=js&"
import style0 from "./DialogReject.vue?vue&type=style&index=0&id=1afda7be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afda7be",
  null
  
)

export default component.exports